import * as React from 'react';

function SvgNavIconPayment(props) {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M7.607 6.067h7.2V4a1 1 0 00-1-1H1.14a1 1 0 00-1 1v8.4a1 1 0 001 1h12.667a1 1 0 001-1v-2.067h-7.2a1.2 1.2 0 01-1.2-1.2V7.267a1.2 1.2 0 011.2-1.2zm8.266 3.066H7.607V7.267h8.266v1.866zm-7.2-.933a.6.6 0 101.2 0 .6.6 0 00-1.2 0z"
      />
    </svg>
  );
}

export default SvgNavIconPayment;
